const tableData = [
      { 
        name: 'AJI SUKMO',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'Cyber',
      },
      { 
        name: 'FIRMAN BACTHIAR',  
        nik: 5103031909700001,
        nkk: 5103031202070062, 
        birthplace: 'MAGELANG',
        datebirth: 'Nov 19, 1990',
        religion: 'budha',
        gender: 'male',
        classification: 'judi',
      },
      { 
        name: 'ARY GUNAWAN',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'BOYOLALI',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'sabung ayam',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'judi',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'judi',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'judi',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA KETUT MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
      { 
        name: 'I DEWA SULE MARDAWA',  
        nik: 5103031909700006,
        nkk: 5103031202070068, 
        birthplace: 'GIANYAR',
        datebirth: 'Sep 19, 1970',
        religion: 'islam',
        gender: 'male',
        classification: 'terorisme',
      },
];

export { tableData };
